import { GET_ANA_CARDS,
  GET_ANALYTICS_BAR,
  GET_ANALYTICS_PURPOSE,
  GET_ANALYTICS_ADDRESS } from "./constant";

export function getAnaCardsRequest(){
  return {
    type:GET_ANA_CARDS.PENDING,
  }
}

export function getAnaCardsSuccess(data){
  return {
    type:GET_ANA_CARDS.SUCCESS,
    data
  }
}

export function getAnaCardsError(err){
  return {
    type:GET_ANA_CARDS.ERROR,
    err
  }
}

export function getAnaBarRequest(){
  return {
    type:GET_ANALYTICS_BAR.PENDING
  }
}

export function getAnaBarSuccess(data){
  return {
    type:GET_ANALYTICS_BAR.SUCCESS,
    data
  }
}

export function getAnaBarError(err){
  return {
    type:GET_ANALYTICS_BAR.ERROR,
    err
  }
}

export function getAnaPurposeRequest(){
  return {
    type:GET_ANALYTICS_PURPOSE.PENDING
  }
}

export function getAnaPurposeSuccess(data){
  return {
    type:GET_ANALYTICS_PURPOSE.SUCCESS,
    data
  }
}

export function getAnaPurposeError(err){
  return {
    type:GET_ANALYTICS_PURPOSE.ERROR,
    err
  }
}


export function getAnaAddressRequest(){
  return {
    type:GET_ANALYTICS_ADDRESS.PENDING
  }
}

export function getAnaAddressSuccess(data){
  return {
    type:GET_ANALYTICS_ADDRESS.SUCCESS,
    data
  }
}

export function getAnaAddressError(err){
  return {
    type:GET_ANALYTICS_ADDRESS.ERROR,
    err
  }
}
